<template>
  <div class="commission-detail">
    <!-- ページタイトル -->
    <div class="page-title d-flex align-items-center">
      <div class="icon-area">
        <img src="@/assets/img/details_sub.jpg" alt="ボーナス明細" />
      </div>
      <h1 class="mb-0">ボーナス明細</h1>
      <div class="back-button" @click="$emit('back')">
        <i class="fa fa-arrow-left"></i> 戻る
      </div>
    </div>

    <!-- コミッション詳細タイトル -->
    <div class="commission-title" style="font-size: 18px;">
      {{ commissionData.month }} 傘下V育成コミッション明細
      
      <a :href="downloadUrl" target="_blank" style="float: right;border:1px solid #000;border: 1px solid #333;padding: 3px 10px;color: #333;background-color: white;margin-top: -4px;">
        <i class="fa fa-print"></i> ダウンロード
      </a>
    </div>

    <!-- ステージごとの詳細 -->
    <div class="detail-section" v-for="stage in commissionData.stages" :key="stage.stage">
      <div class="stage-info">
        <table class="stage-table">
          <tr class="table-header">
            <th class="stage-title-col">段数(単価)</th>
            <th class="stage-data-col">実績数</th>
            <th class="stage-data-col">金額</th>
          </tr>
          <tr>
            <td>{{ stage.stage }}({{ stage.price }}円)</td>
            <td class="text-right">{{ stage.totalCount }}</td>
            <td class="text-right">{{ stage.totalAmount }}円</td>
          </tr>
        </table>
      </div>

      <div class="section-header" @click="toggleStage(stage.stage)">
        <div class="section-title">会員情報</div>
        <div class="section-icon">
          <i :class="['fa', isStageOpen(stage.stage) ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
        </div>
      </div>
      
      <div class="section-content" v-show="isStageOpen(stage.stage)">
        <table class="commission-table">
          <tr class="table-header">
            <th class="col-header">会員番号</th>
            <th class="col-header">実績数</th>
          </tr>
          <tr v-for="member in stage.members" :key="member.number">
            <td>{{ member.number }}</td>
            <td class="text-right">{{ member.count }}</td>
          </tr>
          <tr class="total-row">
            <td class="text-center">計</td>
            <td class="text-right">{{ stage.totalCount }}</td>
          </tr>
        </table>
      </div>
    </div>
    
    <!-- 会社情報 -->
    <div class="company-info text-right mt-3">
      <p class="mb-0">株式会社マナビス化粧品</p>
      <p class="mb-0">登録番号：T3040001030675</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BonusCommissionDetail',
  props: {
    commissionData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      openStages: ["1段目", "2段目", "3段目", "4段目", "5段目", "支援分"], // 初期状態ですべてのステージを開いておく
      downloadUrl: "",  // PDFダウンロード用のURL
    };
  },
  mounted() {
        this.updateDownloadUrl();
	},
  methods: {
    toggleStage(stageNumber) {
      const index = this.openStages.indexOf(stageNumber);
      if (index > -1) {
        this.openStages.splice(index, 1);
      } else {
        this.openStages.push(stageNumber);
      }
    },
    isStageOpen(stageNumber) {
      return this.openStages.includes(stageNumber);
    },
    calculateAmount(count, price) {
        
      // カンマ区切りの数値を処理するため、数値計算用の関数
      const numCount = parseFloat(count.replace(/,/g, ''));
      return Math.floor(numCount * price).toLocaleString();
    },
    printDetail() {
      window.print();
    },
    updateDownloadUrl() {
      
        console.log("commissionData:", this.commissionData);

      // このURLはmounted時と年月変更時に更新される
      // detailDataとmemberプロパティが存在するかチェック
      const memberId = this.commissionData && this.commissionData.member ? this.commissionData.member : "118188";
      const targetMonth = this.commissionData.month ? this.commissionData.month.replace("/", "") : "";
      this.downloadUrl = `/Core/Common/NotificationWeb/PostForWeb?Member=${memberId}&TargetMonth=${targetMonth}&out=1`;
    }
  }
};
</script>

<style scoped>
.commission-detail {
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Hiragino Sans', 'Meiryo', sans-serif;
  color: #333;
  background-color: #fff;
  padding: 20px 30px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.header-logo img {
  height: 40px;
}

.text-center {
  text-align: center;
}

.my-3 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.page-title {
  border-radius: 0;
  padding: 10px 15px;
  margin: 20px 0 15px;
  position: relative;
}

.page-title h1 {
  font-size: 1.2em;
  font-weight: normal;
}

.back-button {
  position: absolute;
  right: 15px;
  cursor: pointer;
  color: #666;
}

.icon-area img {
  width: 75px;
  margin-right: 15px;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.commission-title {
  font-size: 1.2rem;
  font-weight: normal;
  margin: 0 0 15px;
  padding: 8px 12px;
  background-color: #eee;
}

.detail-section {
  margin-bottom: 15px;
  border: 1px solid #ddd;
}

.stage-info {
  width: 100%;
}

.stage-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  margin-bottom: 10px;
}

.stage-table th, .stage-table td {
  padding: 8px 12px;
  border: 1px solid #ddd;
}

.table-header {
  background-color: #eee;
}

.stage-title-col {
  width: 40%;
  text-align: center;
  font-weight: normal;
}

.stage-data-col {
  width: 30%;
  text-align: center;
  font-weight: normal;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #eee;
  cursor: pointer;
  border-top: 1px solid #ddd;
}

.section-title {
  font-weight: normal;
}

.section-info {
  display: flex;
  align-items: center;
}

.section-content {
  padding: 0;
}

.commission-table {
  width: 100%;
  border-collapse: collapse;
  border-top: none;
}

.commission-table th, .commission-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #ddd;
}

.commission-table td {
  padding: 6px 12px;
}

.table-header {
  background-color: #eee;
}

.col-header {
  text-align: center;
  font-weight: normal;
}

.member-col {
  width: 40%;
}

.count-col {
  width: 60%;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.total-row {
  background-color: #eee;
}

.total-row td {
  font-weight: normal;
}

.company-info {
  font-size: 0.95em;
  margin-top: 40px;
}

.mb-0 {
  margin-bottom: 0;
}

.mt-3 {
  margin-top: 15px;
}
</style> 